module.exports = __webpack_public_path__ + "1419024a1f875a2302bd530577a74f26.otf";